import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'
import { ARC, PixelPanel, SectionHead } from '@/components/generals/arcade'
import ContactForm from '@/components/landing/contact/contact-form'
import { CONTACT_PAGE } from '@/components/landing/contact/data'
import { RESUME } from '@/components/landing/cabinet/data'

/* the résumé card again: how to reach me on the left, the form on the right */
const ContactWindow: FC = (): ReactNode => {
    return (
        <section id='message' className={ARC.section} aria-labelledby='message-title' tabIndex={-1}>
            <PixelPanel>
                <div className='grid lg:grid-cols-[minmax(0,0.85fr)_6px_minmax(0,1.35fr)]'>
                    <div className='flex min-w-0 flex-col gap-7 p-6 md:p-10'>
                        <div className='flex flex-col gap-4'>
                            <h2 id='message-title' className={cn(ARC.outline, 'm-0 text-[28px] leading-none lg:text-[36px]')}>
                                {CONTACT_PAGE.title}
                            </h2>
                            <p className={ARC.text}>{CONTACT_PAGE.intro}</p>
                        </div>

                        <div className='flex flex-col gap-4'>
                            <SectionHead icon='contact' label="Contact" />
                            <ul className='m-0 flex list-none flex-col gap-3 p-0 pl-5'>
                                {RESUME.contact.map((c) => (
                                    <li key={c.label} className='flex items-center gap-3.5 text-[15px] md:text-base'>
                                        <span className='-ml-2 size-3.5 flex-none bg-(--cab-peach) shadow-[inset_0_0_0_3px_var(--cab-plum)]' aria-hidden />
                                        <span className='sr-only'>{c.label}: </span>
                                        {c.href ? (
                                            <a href={c.href} className='break-all text-(--cab-teal) underline decoration-2 underline-offset-4 hover:decoration-(--cab-peach)'>
                                                {c.value}
                                            </a>
                                        ) : (
                                            <span className='text-(--cab-teal)'>{c.value}</span>
                                        )}
                                    </li>
                                ))}
                            </ul>
                        </div>

                        <div className='flex flex-col gap-4'>
                            <SectionHead icon='clock' label="Reply time" />
                            <p className={ARC.text}>{CONTACT_PAGE.reply}</p>
                        </div>

                        <div className='flex flex-col gap-4'>
                            <SectionHead icon='gamepad' label="Good fit" />
                            <ul className='m-0 flex list-none flex-wrap gap-2.5 p-0' aria-label="Work I take on">
                                {CONTACT_PAGE.fit.map((f) => (
                                    <li
                                        key={f}
                                        className={cn(ARC.pixel, 'bg-(--cab-sage) px-2.5 py-1.5 text-[11px] tracking-[0.06em] shadow-[inset_0_0_0_2px_var(--cab-plum)]')}
                                    >
                                        {f}
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </div>

                    <div className='h-1.5 bg-(--cab-plum) lg:h-auto' aria-hidden />

                    <div className='flex min-w-0 flex-col gap-7 p-6 md:p-10'>
                        <SectionHead icon='chat' label="Send a message" />
                        <ContactForm />
                    </div>
                </div>
            </PixelPanel>
        </section>
    )
}

export default ContactWindow
